import { render, staticRenderFns } from "./ScoreLine.vue?vue&type=template&id=f135f734&scoped=true"
import script from "./ScoreLine.vue?vue&type=script&lang=js"
export * from "./ScoreLine.vue?vue&type=script&lang=js"
import style0 from "./ScoreLine.vue?vue&type=style&index=0&id=f135f734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f135f734",
  null
  
)

export default component.exports